import * as STD  from '@emersya/mpa-std';
import * as CM   from '@emersya/mpa-components-manager';

export interface IDevToolsConsoleComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class DevToolsConsoleComponent extends CM.DOMComponent<
	HTMLDivElement,
	DevToolsConsoleComponent,
	IDevToolsConsoleComponentConfiguration
> {
	component_DOM: HTMLDivElement;
	eventList: HTMLOListElement;
	uid: number = 0;
	filterString: string = '';
	autoScroll: boolean = true;

	isEventVisible(event: DevToolsEvent.Component) {
		const config = event.component_configuration;

		return config.type.toLowerCase().includes(this.filterString)
			|| config.subType.toLowerCase().includes(this.filterString)
			|| config.content.toLowerCase().includes(this.filterString);
	}

	async onFilter(event: STD.events.Event<any, any>) {
		this.filterString = event.target.value.toLowerCase();

		for (const child of <DevToolsEvent.Component[]>this.component_innerChilds) {
			if (this.isEventVisible(child)) {
				await child.component_enable();
			} else {
				await child.component_disable();
			}
		}
	}

	private async addEvent(type: string, subType: string, content: string) {
		while (this.component_innerChilds.length >= 1000) {
			await (<CM.Component<any, any>>this.component_innerChilds[0]).component_delete();
		}

		const startEvent = this.component_getEventWhichRepresentNoEvent();

		const child = <DevToolsEvent.Component>await this.component_instantiateInnerChild({
			type: 'devTools-event',
			id: (this.uid++).toString(),
			configuration: {
				type,
				subType,
				content,
				time: new Date()
			},
			tree: this,
			slot: null,
			isSlot: false,
			parentNode: this.eventList
		});
		await child.component_initialize();
		await child.component_start(startEvent);

		if (!this.isEventVisible(child)) {
			await child.component_disable();
		}

		if (this.autoScroll) {
			child.component_DOM.scrollIntoView();
		}
	}

	async onConsoleEvent(type: string, data: any[]) {
		await this.addEvent(
			'Console',
			type,
			data.map(d => d.toString()).join(' ')
		);
	}

	async onEventDispatch(event: STD.events.Event<any, any>) {
		if (!(event.target instanceof CM.Component)) {
			return;
		}

		if (this.component_parent?.component_contains(event.target)) {
			return;
		}


		const type = event.type + (event.subType ? ('.' + event.subType) : '');
		const content = event.target.component_getPath();

		await this.addEvent('Event', type, content);
	};

	onEventDispatched(event: STD.events.Event<any, any>) {
		void event;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IDevToolsConsoleComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			childs: [
				{ tag: 'ol', classList: ['event-list'] }
			]
		});
		this.eventList = <HTMLOListElement>this.component_DOM.querySelector('ol');

		this.eventList.addEventListener('scrollend', event => {
			if (!event.isTrusted) return;
			this.autoScroll = this.eventList.scrollTop === (this.eventList.scrollHeight - this.eventList.offsetHeight);
		});
	}

};
export namespace NS {
	export const Component = DevToolsConsoleComponent;
	export type Component = DevToolsConsoleComponent;
	export type Configuration = IDevToolsConsoleComponentConfiguration;
}
import manifestXMLSource          from './DevToolsConsole.xml';
import { NS as DevToolsEvent }    from '../DevToolsEvent/DevToolsEvent';

CM.Manager.declare({
	id: 'devTools-console',
	type: DevToolsConsoleComponent,
	manifest: manifestXMLSource
});
